import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, map, take } from 'rxjs';
import { SessionService } from '../../../../../common/services/session.service';

export const isSurveyAvailable = () => {
    const http = inject(HttpClient);
    const router = inject(Router);
    const session = inject(SessionService);

    return http.head('/api/portal/survey/ping')
        .pipe(
            take(1),
            catchError(e => {
                if (404 === e.status) {
                    router.navigate(['/portail']);
                } else if (401 === e.status) {
                    session.logout();
                }

                return EMPTY;
            }),
            map(() => true),
        );
};
